import { createSelector } from 'reselect';
import { IRootState } from 'src/redux/interface';

export const modalSelector = createSelector(
    (state: IRootState) => state.modal,
    (modal) => modal,
);
